import Helper from '@ember/component/helper';
import { service } from '@ember/service';
export default class ElementRef extends Helper {
  @service elementRefs;

  compute([selector]) {
    return this.elementRefs.refs[selector];
  }
}
